module.exports = __webpack_public_path__ + "media/customizations/wonderlandbyrunway/back-c80f218bbad0d441d225ac8cce1a15f4.jpg";